import BasicFilter from 'components/Icons/BasicFilter';
import SearchInput from 'components/inputs/SearchInput';
import SubmittalListFilterModal from 'components/modals/SubmittalListFilterModal';
import React, { useEffect } from 'react';
import { ModalState } from 'records/ModalState';
import { SubmittalListTypes } from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import ExportButton from '../ExportButton';

type Props = WithAppStoreProps;

const MySubmittalsSubHeader = (props: Props) => {
  const { actions, appState } = props;
  const { translate } = useTranslator(['submittalsPage', 'filters']);

  useEffect(() => {
    return () => {
      actions.clearInteractions();
    };
  }, []);

  const handleSearchChange = (searchString: string): void => {
    const { submittalQuery } = appState;
    const nextSubQuery = submittalQuery.set('search', searchString);
    actions.setSubmittalQuery(nextSubQuery);
  };

  const handleFilterClick = (): void => {
    const modalState = new ModalState({
      id: 'SubmittalListFilter',
      portal: 'main',
      open: true,
      component: SubmittalListFilterModal,
    });

    actions.createModal(modalState);
  };

  const { submittals } = appState;
  return (
    <div>
      <div id="my-subs-subheader" className="column mx4">
        <div className="hs2 my4 row items-center justify-between">
          <div className="mr4 font-size-5 medium color-gray-9">
            {`${translate('submittalsPage:mySubmittals')} (${submittals.size})`}
          </div>
          <div className="row">
            <button
              id="my-subs-subheader-filter-btn"
              className="btn-sm btn-link row items-center justify-between mr4"
              onClick={handleFilterClick}
            >
              <div className="mr2">
                <BasicFilter width="14" height="14" />
              </div>
              <span className="mr2 font-size-4">
                {translate('filters:filter')}
              </span>
            </button>
            <ExportButton
              id="my-subs-subheader-export-btn"
              listType={SubmittalListTypes.MINE}
            />
            <SearchInput
              id="my-subs-subheader-search"
              placeholder={translate('buttons:search')}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(MySubmittalsSubHeader);
